<template>
  <div class="renewal">
    <div class="renewal__header">
      用户：
      <UserSelect
        v-model="searchValue"
        style="margin-right:20px"
        title="全部"
      />
      <span>
        <el-form
          style="height:40px"
          ref="form"
          :model="form"
          label-width="80px"
        >
          <el-form-item label="安装时间：">
            <el-col>
              <el-date-picker
                size="small"
                default-time="00:00:00"
                type="datetime"
                placeholder="开始日期"
                v-model="form.beginTime"
                style="width: 200px;"
              ></el-date-picker>
              -
              <el-date-picker
                size="small"
                type="datetime"
                default-time="23:59:59"
                placeholder="结束日期"
                v-model="form.endTime"
                style="width: 200px;"
              ></el-date-picker>
            </el-col>
          </el-form-item>
        </el-form>
      </span>
      <span class="btnOptions">
        <!-- <el-button
          size="small"
          type="primary"
          @click="setDay(3)"
        >近3天</el-button>
        <el-button
          size="small"
          type="primary"
          @click="setDay(7)"
        >近7天</el-button>
        <el-button
          size="small"
          type="primary"
          @click="setDay(30)"
        >近30天</el-button> -->
        <el-button
          v-for="(item, index) in btns"
          :key="index"
          size="small"
          :type="item.type"
          @click="setDay(item.value,index)"
        >{{item.title}}</el-button>
      </span>
      <span style="margin-left: auto">
        <el-button
          style="margin-left: 32px"
          size="small"
          type="primary"
          @click="getQueryChargeLog()"
        >查询</el-button>
        <!-- <el-button size="small">导出</el-button> -->
      </span>
    </div>
    <div class="counts">
      <span>
        充值总金额:
        <span class="counts__num">{{rmbSum}}</span>
        元
      </span>
      <span>
        充值总设备币:
        <span class="counts__num">{{chargeSum}}</span>
        个
      </span>
      <span>
        赠送总设备币:
        <span class="counts__num">{{giveSum}}</span>
        个
      </span>
      <span>
        币值:
        <span class="counts__num">{{moneyValue}}</span>
        元/个
      </span>
    </div>
    <div
      class="renewal__content"
      :class="{show:flag}"
    >
      <el-table
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(255, 255, 255, 1)"
        :data="tableData.slice((currentPage-1)*pageSize,currentPage*pageSize)"
        border
        stripe
        row-key="vehicleId"
        height="100%"
        max-height="100%"
        style="min-width: 100%"
        size="mini"
        ref="table"
      >
        <el-table-column
          v-for="(item, index) in columns"
          :key="index"
          :prop="item.prop"
          :label="item.label"
          :min-width="item.width"
          align="center"
          :fixed="item.fixed"
        />
      </el-table>
      <!-- 表格结束 -->

      <!-- 分页开始 -->
      <el-pagination
        :current-page.sync="currentPage"
        :page-size.sync="pageSize"
        :page-sizes="[20, 50, 100]"
        layout="total,sizes, prev, pager, next, jumper"
        :total="total"
      />
      <!-- 分页结束 -->
    </div>
  </div>
</template>
<script>
import day from "dayjs";
import UserSelect from "@/components/UserSelect/index.vue";

export default {
  components: {
    UserSelect
  },
  props: {
    activeName: {
      type: String
    }
  },
  data() {
    return {
      loading: false,
      currentPage: 1,
      pageSize: 100,
      total: 0,
      flag: false,
      tableData: [],
      searchValue: null,
      chargeSum: 0,
      giveSum: 0,
      moneyValue: 0,
      rmbSum: 0,
      form: {
        beginTime: day(day(new Date()).subtract(7, "day")).format(
          "YYYY-MM-DD 00:00:00"
        ),
        endTime: day(new Date()).format("YYYY-MM-DD 23:59:59")
      },

      columns: [
        { prop: "index", label: "序号", width: 50, type: 0, fixed: true },
        {
          prop: "chargeCount",
          label: "充值数量",
          width: 80,
          type: 0,
          fixed: false
        },
        {
          prop: "createTime",
          label: "创建时间",
          width: 150,
          type: 0,
          fixed: false
        },
        { prop: "money", label: "充值币", width: 100, type: 0, fixed: false },
        {
          prop: "moneyAfter",
          label: "充值后币数",
          width: 100,
          type: 0,
          fixed: false
        },
        {
          prop: "moneyBefore",
          label: "充值前币数",
          width: 100,
          type: 0,
          fixed: false
        },
        {
          prop: "operName",
          label: "操作人",
          width: 80,
          type: 0,
          fixed: false
        },
        {
          prop: "price",
          label: "价格",
          width: 80,
          type: 0,
          fixed: false
        },
        {
          prop: "rate",
          label: "利率",
          width: 80,
          type: 0,
          fixed: false
        },
        {
          prop: "rmb",
          label: "充值的RMB",
          width: 80,
          type: 0,
          fixed: false
        },
        {
          prop: "userA",
          label: "充值方账号",
          width: 100,
          type: 0,
          fixed: false
        },
        {
          prop: "userB",
          label: "接受充值方账号",
          width: 100,
          type: 0,
          fixed: false
        },
        {
          prop: "years",
          label: "年限",
          width: 80,
          type: 0,
          fixed: false
        },
        {
          prop: "remark",
          label: "赠送说明",
          width: 80,
          type: 0,
          fixed: false
        }
      ],
      btns: [
        { title: "近3天", type: "primary", value: 3 },
        { title: "近7天", type: "primary", value: 7 },
        { title: "近30天", type: "primary", value: 30 }
      ]
    };
  },
  mounted() {},

  computed: {},
  watch: {
    activeName: {
      handler() {
        this.$nextTick(() => {
          this.$refs.table.doLayout();
        });
      },
      deep: true
    }
  },
  methods: {
    async setDay(val, index) {
      this.btns.map(item => {
        item.type = "primary";
      });
      this.btns[index].type = "success";
      this.form.beginTime = day(day(new Date()).subtract(val, "day")).format(
        "YYYY-MM-DD 00:00:00"
      );
      this.form.endTime = day(new Date()).format("YYYY-MM-DD 23:59:59");
      setTimeout(() => {
        this.getQueryChargeLog();
      }, 100);
    },
    async getQueryChargeLog() {
      if (this.form.beginTime === null || this.form.endTime === null) {
        this.$msg({
          showClose: true,
          message: "请选择时间！",
          type: "error"
        });
        return;
      }
      this.flag = true;
      this.loading = true;
      try {
        const { data, total } = await this.$API.getQueryChargeLog({
          startTime:
            (this.form.beginTime &&
              day(this.form.beginTime).format("YYYY-MM-DD HH:mm:ss")) ||
            "",
          endTime:
            (this.form.endTime &&
              day(this.form.endTime).format("YYYY-MM-DD HH:mm:ss")) ||
            "",
          userId: (this.searchValue && this.searchValue.id) || ""
        });
        this.tableData = data.list.map((item, index) => ({
          ...item,
          index: (this.currentPage - 1) * this.pageSize + index + 1
        }));
        this.chargeSum = data.chargeSum || 0;
        this.giveSum = data.giveSum || 0;
        this.moneyValue = data.moneyValue || 0;
        this.rmbSum = data.rmbSum || 0;
        this.total = total || 0;
        this.loading = false;
        if (total === 0) {
          this.$msg({
            showClose: true,
            message: "暂无数据",
            type: "success"
          });
        }
      } catch (error) {
        this.loading = false;
        console.log(error);
        this.$msg({
          showClose: true,
          message: error.msg,
          type: "error"
        });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.renewal {
  overflow: hidden;
  height: calc(100vh - 200px);
  display: flex;
  position: relative;
  &__header {
    position: absolute;
    top: 0;
    display: flex;
    align-items: center;
    height: 40px;
    width: 100%;
    white-space: nowrap;
    & > span {
      height: 40px;
      display: flex;
      align-items: center;
      padding: 0 5px;
      white-space: nowrap;
    }
    .btnOptions {
      // .el-button + .el-button {
      //   margin-left: 1px;
      // }
      // .el-button:nth-child(1) {
      //   border-top-left-radius: 4px;
      //   border-bottom-left-radius: 4px;
      // }

      // .el-button:nth-child(3) {
      //   border-top-right-radius: 4px;
      //   border-bottom-right-radius: 4px;
      // }
    }
  }
  .counts {
    height: 40px;
    display: flex;
    align-items: center;
    position: absolute;
    top: 45px;
    & > span {
      margin-right: -1px;
      border: 1px solid rgb(216, 216, 216);
      padding: 7px;
    }
    &__num {
      color: rgb(65, 206, 182);
    }
  }
  &__content {
    width: 100%;
    position: absolute;
    top: 50px;
    height: calc(100vh - 300px);
    transition: all 0.2s;
  }
}
.show {
  top: 90px !important;
  height: calc(100vh - 340px) !important;
}
</style>